import CheckboxesGroup from "./CheckboxesGroup"

export type { RadioCheckboxesProps } from "./CheckboxesGroup"

export { DropdownCheckboxesGroup } from "./DropdownCheckboxesGroup"

export default CheckboxesGroup
